export const chunkArray = (arr, chunkSize) => {
	if (!chunkSize || !Number(chunkSize) || Number(chunkSize) <= 0) {
		throw Error('Error! Chunk size has to be a positive non-zero number.');
	}
	const output = [];
	for (let i = 0; i < arr.length; i += chunkSize)
		output.push(arr.slice(i, i + chunkSize));
	return output;
};
